<template>
  <div style="height: 100%;">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
/* 确保根元素和容器高度为100% */
html,
body,
#app {
  height: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
  background-color: #F4F6FA;
}

/* router-view容器样式 */
.router-view-container {
  height: 100vh;
  /* 或使用 min-height: 100% */
  width: 100vw;
}

* {
  box-sizing: border-box;
  /* 所有元素默认使用 border-box 设置盒模型：元素的实际宽度 = width（包含 padding 和 border）*/
}

@media (max-width: 1024px) {
  html,
  body,
  #app {
    width: 100%;
    min-width: 0;
    overflow-x: hidden;
  }

  .el-dialog {
    width: calc(100vw - 24px) !important;
    max-width: calc(100vw - 24px);
    margin: 12px auto !important;
  }

  .el-dialog__body {
    max-height: calc(100vh - 48px);
    overflow-y: auto;
  }

  .el-drawer {
    width: 92vw !important;
  }

  .el-message-box {
    width: calc(100vw - 32px) !important;
  }

  .el-table {
    min-width: 640px;
  }

  .el-table__body-wrapper,
  .el-table__header-wrapper {
    overflow-x: auto;
  }

  .el-form-item,
  .el-form-item__content,
  .el-input,
  .el-select,
  .el-date-editor {
    max-width: 100%;
  }
}
</style>
